import React, {useState, useCallback, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup } from 'app/src/elements/buttons';
import { View } from 'react-native';
import { SALE, UPDATE_SALE } from './queries';
import { ButtonContainer } from './elements';
import moment from 'moment';
import { formatDateTimeForInput } from '../../utils/timeFormatter';

import PreBidSchedulePicker from './PreBidSchedules/Picker';

const EditSale = ({setShowModal, refetch, sale, statusUpdate}) => {
  const [submitting, setSubmitting] = useState();
  const [updateSale] = useMutation(UPDATE_SALE, {
    onCompleted: () => {
      if(refetch) {
        refetch();
      }
      setShowModal(false);
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    input['preBidOpenAt'] =
      input['preBidOpenAt'] ?  moment(input['preBidOpenAt'])._d : null;
    input['startAt'] = moment(input['startAt'])._d;
    input['endAt'] = moment(input['endAt'])._d;
    updateSale({ variables: input });
  });

  // const [ loadSale, { loading: loading, data: data } ] =
  // useLazyQuery(SALE, {onCompleted: refetch});

  // if (sale === undefined && id && !loading) {
  //   loadSale({ variables: { id } });
  // }

  const {
    control, handleSubmit, register, setValue, formState: { errors }
  } = useForm({
    defaultValues: {
      id: sale?.id,
      name: sale?.name || '',
      saleOn: sale?.saleOn || '',
      preBidOpenAt: formatDateTimeForInput(sale?.preBidOpenAt) || '',
      startAt: formatDateTimeForInput(sale?.startAt) || '',
      endAt: formatDateTimeForInput(sale?.endAt)  || '',
      status: sale?.status || 'Future',
      preBidScheduleId: sale?.preBidSchedule?.id || '',
      saleType: sale?.saleType || '',
      initialTime: sale?.initialTime || 300,
      retriggerTime: sale?.initialTime || 30,
      addTime: sale?.addTime || 15,
    }
  });

  return (
    <View>
      {submitting ?
        DataState.Loading :
        <View>
          {getInputs()}
          <ButtonContainer>
            <ButtonGroup>
              <Button
                label={statusUpdate ? 'Update Status' : 'Update Sale' }
                onPress={handleSubmit(onSubmit)}
              />
            </ButtonGroup>
          </ButtonContainer>
        </View>
      }
    </View>
  )

  function getInputs() {
    return (
      <View>
        {!statusUpdate &&
          <View>
            <Input.Text
              label="Name:"
              name="name"
              control={control}
              errors={errors}
            />
            <Input.Date
              label="Sale Date:"
              name="saleOn"
              control={control}
              errors={errors}
              {...register('saleOn', { required: 'Required', })}
            />
            <Input.DateTime
              label="Start:"
              name="startAt"
              control={control}
              errors={errors}
            />
            <Input.DateTime
              label="End:"
              name="endAt"
              control={control}
              errors={errors}
            />
            <Input.DateTime
              label="Pre Bid Open At:"
              name="preBidOpenAt"
              control={control}
              errors={errors}
            />
          </View>
        }
        {sale?.saleType == "Timed" &&
                <>
                  <Input.Number
                    label="Initial Time (in Seconds):"
                    name="initialTime"
                    control={control}
                    errors={errors}
                    {...register("initialTime")}
                  />
                  <Input.Number
                    label="Retrigger Time (in Seconds):"
                    name="retriggerTime"
                    control={control}
                    errors={errors}
                    {...register("retriggerTime")}
                  />
                  <Input.Number
                    label="Add Time (in Seconds):"
                    name="addTime"
                    control={control}
                    errors={errors}
                    {...register("addTime")}
                  />
                </>
              }
        <Input.StatusPicker
          label="Status:"
          name="status"
          control={control}
          errors={errors}
        />
        <PreBidSchedulePicker
          control={control}
          errors={errors}
          setValue={setValue}
        />
      </View>
    )
  }
}

export default EditSale;
